if(!customElements.get('mqn-categories'))customElements.define('mqn-categories',class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.resize?.disconnect();
    clearTimeout(this.timer);
    this.controller=new AbortController();
    const opts= {
      signal:this.controller.signal
    }
    ;
    const track=this.querySelector('.mqnc-track'),items=[...this.querySelectorAll('.mqnc-item')],controls=this.querySelector('.mqnc-controls'),toggle=this.querySelector('[data-toggle]'),pause=this.querySelector('[data-pause]');
    const desktop=matchMedia('(min-width:750px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
    let visible=false,hover=false,focus=false,touch=false,selected=false,stopped=reduced.matches;
    const overflows=()=>track.scrollWidth>track.clientWidth+3;
    const schedule=()=> {
      clearTimeout(this.timer);
      if(this.dataset.auto!=='true'||!desktop.matches||!overflows()||!visible||document.hidden||hover||focus||touch||selected||stopped)return;
      this.timer=setTimeout(()=>move(1),Math.max(3000,Number(this.dataset.delay)||5000));
    }
    ;
    const move=direction=> {
      const max=track.scrollWidth-track.clientWidth;
      const step=items.length>1?items[1].offsetLeft-items[0].offsetLeft:track.clientWidth;
      let left=track.scrollLeft+direction*step;
      if(direction>0&&track.scrollLeft>=max-3)left=0;
      if(direction<0&&track.scrollLeft<=3)left=max;
      track.scrollTo( {
        left:Math.max(0,Math.min(max,left)),behavior:reduced.matches?'instant':'smooth'
      }
      );
      schedule();
    }
    ;
    const refresh=()=> {
      if(controls)controls.hidden=!desktop.matches||!overflows();
      if(toggle)toggle.hidden=desktop.matches;
      if(pause) {
        pause.textContent=stopped?'Reanudar':'Pausar';
        pause.setAttribute('aria-pressed',String(stopped));
        pause.setAttribute('aria-label',stopped?'Reanudar desplazamiento automático':'Pausar desplazamiento automático');
      }
      schedule();
    }
    ;
    this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),opts);
    this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),opts);
    pause?.addEventListener('click',()=> {
      stopped=!stopped;
      refresh();
    }
    ,opts);
    toggle?.addEventListener('click',()=> {
      const expanded=this.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded',String(expanded));
      toggle.querySelector('span').textContent=expanded?'Ver menos':'Ver todo';
      if(!expanded)toggle.scrollIntoView( {
        block:'nearest',behavior:'instant'
      }
      );
    }
    ,opts);
    this.addEventListener('pointerenter',e=> {
      if(e.pointerType==='mouse') {
        hover=true;
        schedule();
      }
    }
    ,opts);
    this.addEventListener('pointerleave',()=> {
      hover=false;
      schedule();
    }
    ,opts);
    this.addEventListener('pointerdown',()=> {
      touch=true;
      schedule();
    }
    ,opts);
    ['pointerup','pointercancel'].forEach(type=>window.addEventListener(type,()=> {
      touch=false;
      schedule();
    }
    ,opts));
    this.addEventListener('focusin',()=> {
      focus=true;
      schedule();
    }
    ,opts);
    this.addEventListener('focusout',e=> {
      focus=this.contains(e.relatedTarget);
      schedule();
    }
    ,opts);
    track.addEventListener('scroll',schedule,opts);
    document.addEventListener('visibilitychange',schedule,opts);
    desktop.addEventListener('change',refresh,opts);
    reduced.addEventListener('change',()=> {
      if(reduced.matches)stopped=true;
      refresh();
    }
    ,opts);
    document.addEventListener('shopify:block:select',e=> {
      const item=items.find(x=>x.dataset.block===e.detail.blockId);
      if(!item)return;
      selected=true;
      if(!desktop.matches) {
        this.classList.add('is-expanded');
        if(toggle) {
          toggle.setAttribute('aria-expanded','true');
          toggle.querySelector('span').textContent='Ver menos';
        }
      }
      else track.scrollTo( {
        left:item.offsetLeft-items[0].offsetLeft,behavior:'instant'
      }
      );
      schedule();
    }
    ,opts);
    document.addEventListener('shopify:block:deselect',e=> {
      if(items.some(x=>x.dataset.block===e.detail.blockId)) {
        selected=false;
        schedule();
      }
    }
    ,opts);
    this.observer=new IntersectionObserver(entries=> {
      visible=entries[0].isIntersecting;
      schedule();
    }
    , {
      threshold:.15
    }
    );
    this.observer.observe(this);
    this.resize=new ResizeObserver(refresh);
    this.resize.observe(track);
    this.classList.add('is-ready');
    refresh();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.resize?.disconnect();
    clearTimeout(this.timer);
  }
}
);
